import { render, staticRenderFns } from "./Upsell.vue?vue&type=template&id=a848ae12&"
import script from "./Upsell.vue?vue&type=script&lang=js&"
export * from "./Upsell.vue?vue&type=script&lang=js&"
import style0 from "./Upsell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports